import { useSettings, useStyles } from '@wix/tpa-settings/react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import settingsParams, {
  uninitializedVisibilitySettingsTrueValue,
} from '../settingsParams';
import { useAllBreakpointsStyles } from '../Widget/hooks/useAllBreakpointsStyles';
import { VisibilityKey } from './types';

function useCachedStyles() {
  const styles = useStyles();
  const { isEditor } = useEnvironment();
  const stylesMightChange = isEditor;
  const stylesForAllBreakpoints = useAllBreakpointsStyles();

  return {
    getStylesForAllBreakpoints() {
      return !stylesForAllBreakpoints || stylesMightChange ? styles.getStylesForAllBreakpoints() : stylesForAllBreakpoints;
    },
  };
}

export function useVisibilityCheck() {
  const settings = useSettings();
  const { getStylesForAllBreakpoints } = useCachedStyles();
  const { isCssPerBreakpoint } = useEnvironment();

  return {
    shouldBeVisible(key: VisibilityKey) {
      const settingsValue = settings.get(settingsParams[key]);
      if (isCssPerBreakpoint) {
        return typeof settingsValue === 'boolean'
          ? settingsValue
          : getStylesForAllBreakpoints().some(({ booleans }) => booleans[key]);
      } else {
        return typeof settingsValue === 'boolean'
          ? settingsValue
          : settingsValue === uninitializedVisibilitySettingsTrueValue;
      }
    },
  };
}
